var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.permission(310))?_c('a',{staticClass:"mag-header-events",attrs:{"href":"/tourclient/admin/events/index.html"}},[_c('i',{staticClass:"mag-icon-nav-top-alarm"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items),expression:"items"}],staticClass:"mag-header-events__badge"},[_vm._v(_vm._s(_vm.items))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }